import LoadingButton from "@mui/lab/LoadingButton";
import { Button, Stack, StackProps, Typography } from "@mui/material";

interface PopupFooterProps {
  footerSubtext?: string;
  confirmText: string;
  cancelText?: string;
  justifyContent?: StackProps["justifyContent"];
  onConfirm: () => void;
  onCancel?: () => void;
  loading?: boolean;
}

const PopupFooter = ({
  confirmText,
  cancelText,
  justifyContent = "center",
  onConfirm,
  onCancel,
  footerSubtext,
  loading,
}: PopupFooterProps) => {
  return (
    <Stack sx={{ pt: 1 }} alignItems="center">
      <Stack
        direction="row"
        justifyContent={justifyContent}
        spacing="9px"
        sx={{ height: "46px", width: "100%" }}
      >
        {onCancel && (
          <Button variant="text" color="primary" onClick={onCancel}>
            {cancelText}
          </Button>
        )}
        <LoadingButton
          variant="contained"
          color="primary"
          onClick={onConfirm}
          sx={{ width: onCancel ? undefined : "100%" }}
          loading={loading}
        >
          {confirmText}
        </LoadingButton>
      </Stack>
      {footerSubtext && (
        <Typography
          variant="labelReg"
          sx={{
            mt: "9px",
            color: "shades.neutral.700",
            letterSpacing: "-0.01rem",
          }}
        >
          {footerSubtext}
        </Typography>
      )}
    </Stack>
  );
};
export default PopupFooter;
